function jlr_contains_value(text, words) {
  const array = words.toLowerCase().split('-');
  const totalWords = array.length;
  const vehicle = text.toLowerCase().split('-');
  let totalCoincidences = 0;

  array.forEach(item => {
    const totalI = vehicle.filter(varItem => varItem.includes(item)).length;
    const totalP = vehicle.filter(varItem => 
      varItem.replace(/-/g, '').includes(item.replace(/-/g, ' '))
    ).length;

    if (totalI > 0 || totalP > 0) {
      totalCoincidences++;
    }
  });

  return totalWords === totalCoincidences;
}

function findFormType(searchString) {
  const formTypes = [  {    "forms": [      {        "formtype": "Get a Quote",        "coincidences": "get-a-quick-quote"      },      {        "formtype": "Test Drive",        "coincidences": "test-drive, book-a-test-drive"      },      {        "formtype": "Request More Info",        "coincidences": "request-more-information, request-more-info, confirm-availability, check-availability"      },      {        "formtype": "email a Friend",        "coincidences": "email-a-friend"      },      {        "formtype": "General Contact",        "coincidences": "contact, contact-us"      },      {        "formtype": "Service",        "coincidences": "service"      },      {        "formtype": "Parts",        "coincidences": "parts, request-parts"      },      {        "formtype": "Schedule Service",        "coincidences": "schedule-service, service-appointment,book-an-appointment"      },      {        "formtype": "Employment",        "coincidences": "employment, job-opportunities, employment-opportunities"      },      {        "formtype": "Trade In",        "coincidences": "trade-in, trade-in-appraisal, trade-in-value"      },      {        "formtype": "Finance",        "coincidences": "finance,financing"      },      {        "formtype": "Payment Estimator",        "coincidences": "payment-estimator, payment-calculator"      },      {        "formtype": "Specials",        "coincidences": "specials"      },      {        "formtype": "Vehicle Finder",        "coincidences": "vehicle-finder"      },      {        "formtype": "Dealer Custom",        "coincidences": "dealer-custom"      },      {        "formtype": "Make an Offer",        "coincidences": "make-an-offer"      },      {        "formtype": "Send to Mobile",        "coincidences": "send-to-mobile"      },      {        "formtype": "Other",        "coincidences": "other"      }    ]  }];

  for (const form of formTypes[0].forms) {
    const coincidencesArray = form.coincidences.split(',');
    for (const coincidence of coincidencesArray) {
      if (jlr_contains_value(searchString, coincidence.trim())) {
        return form.formtype;
      }
    }
  }
  return 'Other';
}

document.addEventListener('DOMContentLoaded', () => {
  const modalIds = document.querySelectorAll(".open-form");

  modalIds.forEach((modal) => {
    const modalId = modal.id;
    
      if(modalId != '' && modalId != undefined){
        setTimeout(() => { 
            jQuery("."+modalId).on('click', function() {
              jQuery('.form-'+modalId).removeClass('hidden');
              jQuery('.form-'+modalId).addClass('flex');
  
              var jsonValue = document.getElementById('data-'+modalId).value;
              var vehicle_data = JSON.parse(jsonValue);
              
              var vid_hidden    = jQuery('.form-'+modalId+' .fs-'+modalId+' input[type=hidden]').value;
              
              // Add vehicle id to hidden
              if(vid_hidden == '' || vid_hidden == undefined)
                jQuery('.form-'+modalId+' .fs-'+modalId+' input[type=hidden]:not(.datepicker)').val(vehicle_data.vehicle_id);
  
                if(document.getElementById("shiftdigital-script") != null) {
  
                  if(!sessionStorage.getItem('formEventts') || (Date.now() - sessionStorage.getItem('formEventts'))/1000 > 2 ){
                    sessionStorage.setItem('formEventts', new Date().getTime());
  
                      sd('dataLayer',{
                        formType: findFormType(document.getElementById(`${modalId}-modal-name`).value),
                        displayType: 'modal',
                        events: 'formShown',
                        formVehicle: {
                          status: vehicle_data.certified ? 'CPO' : vehicle_data.condition,
                          year: vehicle_data.year,
                          make: vehicle_data.make,
                          model: vehicle_data.model,
                          trim: vehicle_data.trim,
                          engine: vehicle_data.engine,
                          transmission: vehicle_data.transmission,
                          drivetrain: vehicle_data.drivetrain,
                          interiorcolor: vehicle_data.interiorcolor,
                          exteriorcolor: vehicle_data.exteriorcolor,
                          vin: vehicle_data.vin,
                          msrp: vehicle_data.msrp,
                          displayedPrice: vehicle_data.displayedPrice,
                          fuelType: 'Gasoline'
                        }
                      });
                      sd('send');
  
                      // Form initiation event   
                      const divs = document.querySelectorAll('.nf-element');
                      var fired = false;
                      
                      divs.forEach(el => el.addEventListener('click', event => {
                        if(fired) return;
  
                        sd('dataLayer',{
                          formType: findFormType(document.getElementById(`${modalId}-modal-name`).value),
                          displayType: 'modal',
                          events: 'formInitiation'
                        });
                        sd('send');
                        fired = true;
  
                      }));
  
                      jQuery(document).on('nfFormSubmitResponse', function(event, response, id) {      
                        // JLR FORM SUBMIT SEND EVENT
                        sd('dataLayer',{
                            leadId: makeid(15),
                            formType: findFormType(document.getElementById(`${modalId}-modal-name`).value),
                            leadType: 'lead',
                            displayType: 'modal',
                            events: 'formSubmission'
                        });
                        sd('send');
                
                      });
                  }
                }
  
              var modalScript = "jQuery(document).ready(function() {"+
                    "jQuery(document).on('nfFormSubmitResponse', function(event, response, id) {"+ 
                    "jQuery('.lbx-modal-vehicle-section.vs-"+modalId+"').css('display', 'none');"+
                    "jQuery('.lbx-modal-form-section.fs-"+modalId+"').css({'width': '100%', 'text-align': 'center', 'padding': '60px'});"+
                    "jQuery('.lbx-modal-form-send.fsd-"+modalId+", .cta-continue-browsing.cb-"+modalId+"').removeClass('hidden');"+
                    "jQuery('.cta-continue-browsing.cb-"+modalId+"').addClass('flex'); "+
                    "var formName = '"+modalId.replace(/-/g, " ")+"';"+
                    "if (formName == '')"+
                    "  formName = 'form title not set';"+
                    "var year = '"+vehicle_data.year+"'; "+
                    "var make = '"+vehicle_data.make+"'; "+
                    "var model = '"+vehicle_data.model+"'; "+
                    "var trim = '"+vehicle_data.trim+"'; "+
                    "var stocknumber = '"+vehicle_data.stocknumber+"'; "+
                    "var vehicleData = '"+vehicle_data.year+"-"+vehicle_data.make+"-"+vehicle_data.model+"-"+vehicle_data.trim +"-"+vehicle_data.stocknumber+"'; "+
                    "var label = '"+modalId.replace(/-/g, " ")+"-"+vehicle_data.year+"-"+vehicle_data.make+"-"+vehicle_data.model+"-"+vehicle_data.trim +"-"+vehicle_data.stocknumber+"'; "+
                    "var payLoad = { "+
                      "'event_category': 'LBX-Form',"+
                      "'event_label': label"+
                    "}; "+
                    "window.sendGAEvent('LBX-Submit', payLoad); "+
                  "});"+
              "});";
              
              if(jQuery('.script-'+modalId).length <= 0)
                jQuery('.form-'+modalId).append("<script type='application/javascript' class='script-"+modalId+"'>" + modalScript);
            });
  
  
          jQuery(".form-" + modalId).find(".bg-black").on("click", function () {
            jQuery(".form-" + modalId).addClass("hidden");
            jQuery(".script-" + modalId).remove();
          });
  
          jQuery(".close-form-" + modalId).on("click", function () {
            jQuery(".form-" + modalId).addClass("hidden");
            jQuery(".script-" + modalId).remove();
          });
  
          var continueBrowsingButton = jQuery(".lbx-continue-browsing-" + modalId);
  
          if (continueBrowsingButton.length > 0) {
            continueBrowsingButton.on("click", function () {
              jQuery(".form-" + modalId).addClass("hidden");
              jQuery(".script-" + modalId).remove();
            });
          }
  
        }, 200);
      }
  });
});